// Reactive подписка на токен из lib/auth-storage. Source of truth: docs/specs/sprint-3/stage-4-screens.md §3.1.
//
// useSyncExternalStore — getSnapshot вызывается на каждом render'е, что важно
// для V-9: внешний `localStorage.clear()` (DevTools) не триггерит notify, но
// peekToken() на web всегда re-reads localStorage, поэтому следующий render
// (от любой причины — нав, mutation onSuccess) подхватит свежее значение.

import { useEffect, useSyncExternalStore } from 'react';
import { getToken, peekToken, subscribeToken } from '@/lib/auth-storage';

export type TokenState = { token: string | null; isLoaded: boolean };

export function useToken(): TokenState {
  const value = useSyncExternalStore(subscribeToken, peekToken, peekToken);

  useEffect(() => {
    // Native cold-start: peekToken() === undefined → инициируем async-load.
    // На web peekToken sync-читает localStorage, так что эта ветка не сработает.
    if (peekToken() === undefined) {
      void getToken();
    }
  }, []);

  if (value === undefined) return { token: null, isLoaded: false };
  return { token: value, isLoaded: true };
}
